<script lang="ts">
    import translations from './translations';
    import { getCookiePreferences, setCookiePreferences } from '$lib/helper';
    import { mediaCookiesAccepted } from '$lib/Stores/stores';
    import Box from '$lib/components/_DisplayComponents/_wrappers/Box.svelte';
    import Limiter from '$lib/components/_DisplayComponents/_wrappers/Limiter.svelte';
    import Transition from '$lib/components/_DisplayComponents/_wrappers/Transition.svelte';
    import { base } from '$app/paths';

    // Types
    import type { Language } from '$lib/types/Language';
    import type { TransitionEffect } from '$lib/types/Theme';

    export let campaignId = '';
    export let language: Language = 'de';
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let bgColor = 'transparent';

    const handleAccept = () => {
        const cookies = getCookiePreferences(campaignId);

        const updatedCookies = Object.assign({}, cookies);
        updatedCookies.Media = true;

        setCookiePreferences(campaignId, updatedCookies);

        $mediaCookiesAccepted = true;
    };
</script>

<Box top="medium" right="medium" bottom="medium" left="medium" backgroundColor={bgColor}>
    <Limiter narrow>
        <Transition delay={transitionDelay} effect={transitionEffect}>
            <div
                class="mx-auto max-w-md rounded-lg border border-gray-200 bg-white p-5 text-center font-ui"
            >
                <p class="text-sm font-medium text-gray-600">
                    {translations[language].externalContent}
                </p>
                <p class="mt-1 text-sm text-gray-600">
                    {translations[language].bodyPreLink}<a
                        href={`${base}/consent-policy`}
                        class="border-b border-gray-400 transition hover:border-gray-600"
                        >{translations[language].cookies}</a
                    >{translations[language].bodyPostLink}
                </p>
                <button
                    class="mt-5 w-full rounded-lg bg-gray-100 py-2 text-sm font-medium text-gray-600 transition hover:bg-gray-200"
                    on:click={handleAccept}>{translations[language].accept}</button
                >
            </div>
        </Transition>
    </Limiter>
</Box>
